import { Routes, Route, Navigate } from "react-router-dom";
import {
  HubRoutes,
  LearningCenterRoutes,
  EventRegistrationRoutes,
  ProductDirectoryRoutes,
  StochasticRoutes,
  AdminRoutes,
  CoachingRoutes,
  SubscriptionRoutes,
  EmployeeDirectoryRoutes,
} from "./routes";
import { TermsOfService } from "../components/TermsOfService/TermsOfService";
import Logout from "../modules/hub/features/Auth/components/Logout/Logout";
import ForbiddenPage from "@/modules/hub/features/Auth/components/ForbiddenPage/ForbiddenPage";
import { PublicPayPage } from "@/modules/eventRegistration/features/PaymentRequests/components/PublicPayPage/PublicPayPage";

function AppRoutes() {
  return (
    <Routes>
      <Route element={<Navigate replace to="/hub" />} path="/" />

      <Route
        element={<Navigate replace to="/certain-path/coaches-dashboard" />}
        path="/certain-path"
      />

      <Route
        element={<TermsOfService />}
        path="/certain-path/terms-of-service"
      />

      <Route element={<ForbiddenPage />} path="/403" />

      <Route element={<PublicPayPage />} path="/pay/:token" />

      {LearningCenterRoutes}
      {HubRoutes}
      {EventRegistrationRoutes}
      {ProductDirectoryRoutes}
      {StochasticRoutes}
      {AdminRoutes}
      {CoachingRoutes}
      {SubscriptionRoutes}
      {EmployeeDirectoryRoutes}
      <Route element={<Logout />} path="/logout" />
    </Routes>
  );
}

export default AppRoutes;
